import React, { useState } from "react";
import { string, object, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Button from "../../atoms/Button";
import LoginMobile from "../../atoms/icons/login";
import LoginRegister from "../../molecules/LoginRegister";
import LoginFirstLook from "../../molecules/LoginFirstLook";
import MemberNotVerifiedView from "../../molecules/MemberNotVerifiedView";

import { logout } from "../../helper/api";
import { staticTexts } from "../../utils/Translate";

import "./auth-view.m.css";

const AuthView = ({
  pageType,
  member,
  domainSlug,
  navigateToPage,
  currentPath,
  currentHostUrl,
  authHost,
  publisherAttributes
}) => {
  const [type, setType] = useState(null);

  const toggleGuestUserDropdown = () => (type ? setType(null) : setType("login_signup"));
  const toggleLoginFirstLookView = () => (type ? setType(null) : setType("login_lookup"));
  const toggleMemberNotVerifiedView = () => (type ? setType(null) : setType("not_verified_user"));

  const logoutClick = () => {
    logout().then(() => {
      window.location.reload();
    });
  };

  // User not verified
  const notVerifiedView = () => (
    <React.Fragment>
      {/* Not Verified User Popup Button */}
      <div styleName="auth-wrapper">
        <Button
          content={staticTexts(publisherAttributes.lang).emailVerification}
          buttonType="type4"
          isArrow={true}
          className="desktop-btn"
          isOpen={type === "not_verified_user"}
          onClick={toggleMemberNotVerifiedView}
        />
        {/* Mobile Login Popup Button */}
        <div styleName="mobile-btn" className="mobile-btn" onClick={toggleGuestUserDropdown}>
          <LoginMobile />
        </div>
      </div>

      {/* MemberNotVerifiedView Overlay */}
      {type === "not_verified_user" ? (
        <MemberNotVerifiedView
          closeView={toggleMemberNotVerifiedView}
          logout={logoutClick}
          navigateToPage={navigateToPage}
          member={member}
        />
      ) : null}
    </React.Fragment>
  );

  // Verified User
  const loggedInView = () => {
    if (pageType === "profile-page") {
      // Show logout button if its profile page
      return <Button content={staticTexts(publisherAttributes.lang).logOut} buttonType="type4" onClick={logoutClick} />;
    }

    return (
      <div styleName="auth-wrapper">
        <Button
          content={staticTexts(publisherAttributes.lang).profile}
          buttonType="type4"
          isArrow={true}
          className="desktop-btn"
          isOpen={type === "login_lookup"}
          onClick={toggleLoginFirstLookView}
        />

        {/* Mobile Login Popup Button */}
        <div styleName="mobile-btn" className="mobile-btn" onClick={toggleLoginFirstLookView}>
          <LoginMobile color={domainSlug === "kishoralo" ? "#121212" : "#555555"} />
        </div>

        {type === "login_lookup" ? (
          <LoginFirstLook
            closeView={toggleLoginFirstLookView}
            member={member}
            pageType={pageType}
            logout={logoutClick}
          />
        ) : null}
      </div>
    );
  };

  // Not logged in User
  const loginView = () => (
    <React.Fragment>
      {/* Desktop Login Popup Button */}
      <div styleName="auth-wrapper">
        <Button
          content={staticTexts(publisherAttributes.lang).login}
          buttonType="type4"
          isArrow={true}
          className="desktop-btn"
          isOpen={type === "login_signup"}
          onClick={toggleGuestUserDropdown}
        />
        {/* Mobile Login Popup Button */}
        <div styleName="mobile-btn" className="mobile-btn" onClick={toggleGuestUserDropdown}>
          <LoginMobile color={domainSlug === "kishoralo" ? "#121212" : "#555555"} />
        </div>
      </div>

      {/* Login/Signup Overlay */}
      {type === "login_signup" ? (
        <LoginRegister
          currentPath={currentPath}
          currentHostUrl={currentHostUrl}
          closeView={toggleGuestUserDropdown}
          authHost={authHost}
        />
      ) : null}
    </React.Fragment>
  );

  if (member) {
    if (member["verification-status"]) {
      return loggedInView();
    } else {
      return notVerifiedView();
    }
  }

  return loginView();
};

AuthView.propTypes = {
  pageType: string,
  member: object,
  navigateToPage: func,
  domainSlug: string,
  currentPath: string,
  currentHostUrl: string,
  authHost: string,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    currentPath: get(state, ["qt", "currentPath"], ""),
    currentHostUrl: get(state, ["qt", "currentHostUrl"], ""),
    pageType: get(state, ["qt", "pageType"], null),
    member: state.member || null,
    domainSlug: get(state, ["qt", "domainSlug"]),
    authHost: get(state, ["qt", "config", "publisher-attributes", "auth_host"], null),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

const mapDispatchToProps = dispatch => ({
  navigateToPage: url => global.app.navigateToPage(dispatch, url)
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthView);
